import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService, DialogService, CoreService, DspxCardSetBaseFormComponent } from 'dspx-core';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { VptasSpecialistGridFilterRequest } from 'src/app/interfaces/vptas-specialist-grid-filter-request.interface';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { Mapper, MapperBuilder } from 'src/app/helpers/mapper';
import { nameof } from 'src/app/helpers/nameof';

@Component({
  selector: 'app-vptas-specialist-list',
  templateUrl: './vptas-specialist-list.component.html',
  styleUrl: './vptas-specialist-list.component.scss'
})
export class VptasSpecialistListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value;
  }

  activeDialog: string = '';
  filterQuestionToFilterModelMapper: Mapper;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.vptasSpecialistList,
      () => {
        return API_ENDPOINTS.dashboard.getVptasSpecialists;
      },
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.firstNameFilter, null, nameof<VptasSpecialistGridFilterRequest>('firstName'))
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.middleNameFilter, null, nameof<VptasSpecialistGridFilterRequest>('middleName'))
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.lastNameFilter, null, nameof<VptasSpecialistGridFilterRequest>('lastName'))
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.providerNumberFilter, null, nameof<VptasSpecialistGridFilterRequest>('providerNumber'))
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.suburbFilter, null, nameof<VptasSpecialistGridFilterRequest>('suburb'))
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.specialtiesFilter, null, nameof<VptasSpecialistGridFilterRequest>('specialties'))
        .MapFrom(FILTER_QUESTION_CODES.vptasSpecialistListForm.stateFilter, null, nameof<VptasSpecialistGridFilterRequest>('state'))
        .BuildMapper();
  }

  ngOnInit(): void {
    //throw new Error('Method not implemented.');
  }

  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad(this.getSpecialistFilterRequest());
  }

  filterData(event: any): void {
    const filterRequest = this.getSpecialistFilterRequest();
    this.loadGridData(filterRequest);
  }

  actionButton_specialistsGrid_datagrid_edit_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.VptasSpecialist.prefix, event.event.data.id]);
  }

  actionButton_specialistsGrid_datagrid_custom_createSpecialist_Clicked(event: any) {
    this.router.navigate([ROUTE_CONSTANTS.VptasSpecialist.new]);
  }

  private getSpecialistFilterRequest(): VptasSpecialistGridFilterRequest {
    const vptasSpecialistGridFilterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.vptasSpecialistListForm.specialists,
      PAGE_NUMBERS.vptasSpecialistListForm.specialists,
      SECTION_CODES.vptasSpecialistListForm.specialists,
      QUESTION_CODES.vptasSpecialistListForm.specialistsGridFilter
    );
    const filterRequest: VptasSpecialistGridFilterRequest = {
      firstName: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.firstNameFilter
      ] || '',
      middleName: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.middleNameFilter
      ] || '',
      lastName: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.lastNameFilter
      ] || '',
      providerNumber: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.providerNumberFilter
      ] || '',
      suburb: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.suburbFilter
      ] || '',
      specialties: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.specialtiesFilter
      ] || '',
      state: vptasSpecialistGridFilterModel?.[
        FILTER_QUESTION_CODES.vptasSpecialistListForm.stateFilter
      ] || ''
    };
    return filterRequest;
  }
}
